export default __webpack_public_path__ + "static/image-906-9754d901e3c9fa25f930e06e0d32ac17.png";